module.exports = {"511524100":"长宁镇","511524101":"梅硐镇","511524102":"双河镇","511524103":"硐底镇","511524104":"花滩镇","511524105":"竹海镇","511524106":"老翁镇","511524107":"古河镇","511524110":"龙头镇","511524112":"铜鼓镇","511524113":"井江镇","511524114":"铜锣镇","511524115":"梅白镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511524.json
// module id = 2491
// module chunks = 0